import * as React from 'react';
import {
    UserOutlined,
    InstagramFilled,
    FacebookFilled,
    LinkedinFilled,
} from '@ant-design/icons';
import { Suspense, useEffect, useState } from 'react';

import {
    Layout,
    Typography,
    Menu,
    Avatar,
    Row,
    Col,
} from 'antd';
import { useTranslation } from 'react-i18next';

import LoaderOverlay from 'shared/components/LoaderOverlay';

import './Layout.scss';
import { NavLink, useHistory } from 'react-router-dom';
import { AuthConsumer } from '../../contexts/AuthContext';
import { useLocation } from 'react-use';
import Parameters from 'shared/parameters';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

export default function DesktopSuperAdminLayout({
                                                    children,
                                                }: any) {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('/organizations' as string);
    useEffect(() => {
        if (location.pathname)
            setActiveTab(location.pathname);
    }, [location]);

    const handleClick = (e: any) => {
        history.push(e.key);
        return true;
    };
    return (
        <AuthConsumer>
            {({ isAuth, updateCart, cartTime, cart, user }) => (
                <Layout
                    style={{ minHeight: '100vh' }}
                    className={`desktop-layout`}>
                    <Header>
                        <Row gutter={20} align={'middle'}>
                            <Col flex={'auto'}>
                                <Row gutter={20}>
                                    <Col>
                                        <div className="custom-nav-link">
                                            <NavLink to={'/'} style={{fontSize: "26px",fontWeight: "700"}}>
                                                {Parameters.ClientName}
                                            </NavLink>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Col>
                                        {
                                            user ? <>
                                                <NavLink to={'/my/profile'} activeClassName="active-nav-link">
                                                    <div className="custom-nav-link account-details">
                                                        <Avatar size={30} icon={<UserOutlined/>}/>
                                                        <Text style={{ marginTop: '4px' }}>{user.name}</Text>
                                                    </div>
                                                </NavLink>
                                            </> : <NavLink to={'/login'} activeClassName="active-nav-link">
                                                <div className="custom-nav-link">
                                                    {t('genDict.login')}
                                                </div>
                                            </NavLink>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Header>
                    <Layout>
                        <Sider className={'sider-wrapper'} width={256} theme={'light'}>
                            <div className="menu-wrapper">
                                <Menu
                                    onClick={handleClick}
                                    style={{ width: 256 }}
                                    selectedKeys={[activeTab]}
                                    mode="inline"
                                >
                                    <Menu.ItemGroup className='text-white' key="groupOrg" title={t('genDict.organizations')}>
                                        <Menu.Item className='text-white' key="/organizations">{t('genDict.organizations')}</Menu.Item>
                                        <Menu.Item className='text-white' key="/admins">{t('genDict.admins')}</Menu.Item>
                                    </Menu.ItemGroup>
                                    <Menu.ItemGroup className='text-white' key="group-reports" title={t('genDict.reports')}>
                                        {/* <Menu.Item className='text-white' key="/reports/orders">{t('genDict.ordersReport')}</Menu.Item> */}
                                        <Menu.Item  className='text-white'
                                            key="/reports/instructors">{t('genDict.instructorsReport')}</Menu.Item>
                                        <Menu.Item className='text-white' key="/reports/students">{t('genDict.studentsReport')}</Menu.Item>
                                        {/* <Menu.Item className='text-white' key="/reports/learners">{t('genDict.learnersReport')}</Menu.Item> */}
                                        <Menu.Item className='text-white' key="/reports/courses">{t('genDict.coursesReport')}</Menu.Item>
                                    </Menu.ItemGroup>
                                </Menu>
                            </div>
                        </Sider>

                        <Content className={'content-layout'}>
                            <Suspense fallback={<LoaderOverlay size="large" loading={true}/>}>
                                {children}
                            </Suspense>
                        </Content>
                    </Layout>
                </Layout>
            )
            }
        </AuthConsumer>
    );
}
